/* Confirmed merchandise facts only. No customer data, cart token or properties. */
(() => {
  if (window.HydeNetCart) return;
  const privacyReady = new Promise(resolve => {
    if (window.Shopify?.customerPrivacy) return resolve();
    const timer = setTimeout(resolve, 1500);
    try {
      window.Shopify?.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {
        clearTimeout(timer); resolve();
      });
    } catch (_) { clearTimeout(timer); resolve(); }
  });
  async function added(requested, currentCart) {
    try {
      await privacyReady;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      if (!window.Shopify?.analytics?.publish || !Array.isArray(requested)) return;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 1500);
      let cart;
      try {
        if (currentCart) cart = currentCart;
        else {
          const response = await fetch((Shopify.routes?.root || '/') + 'cart.js', {
            cache: 'no-store', headers: {Accept: 'application/json'}, signal: controller.signal
          });
          if (!response.ok) return;
          cart = await response.json();
        }
      } finally { clearTimeout(timer); }
      const facts = requested.map(request => {
        const matches = cart.items.filter(line => String(line.variant_id) === String(request.id));
        const line = matches.find(line => request.key && request.key === line.key) ||
          (matches.length === 1 ? matches[0] : null);
        const count = Number(request.quantity);
        if (!line || !Number.isSafeInteger(count) || count <= 0 || line.quantity < count) {
          throw new Error('ambiguous_cart_line');
        }
        return {quantity: count, merchandise: {
          id: String(line.variant_id), title: line.variant_title || '', sku: line.sku || '',
          price: {amount: line.original_price / 100, currencyCode: cart.currency},
          product: {id: String(line.product_id), title: line.product_title, vendor: line.vendor}
        }, current: {variant_id: line.variant_id, product_id: line.product_id,
          quantity: line.quantity, final_line_price: line.final_line_price}};
      });
      await Shopify.analytics.publish('hyde_net_cart_confirmed', {currency: cart.currency, lines: facts});
    } catch (_) { /* Measurement must never retry the cart mutation or block buying. */ }
  }
  const pendingKey = 'hyde-net-cart-pending-v1';
  async function queueForCart(requested) {
    try {
      await privacyReady;
      if (Shopify.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      sessionStorage.setItem(pendingKey, JSON.stringify({created: Date.now(),
        requested: requested.map(row => ({id: String(row.id), quantity: Number(row.quantity)}))}));
    } catch (_) { /* Storage denial must not block checkout. */ }
  }
  async function consumePending() {
    try {
      await privacyReady;
      if (!/\/cart\/?$/.test(location.pathname)) return;
      const raw = sessionStorage.getItem(pendingKey);
      if (!raw) return;
      sessionStorage.removeItem(pendingKey);
      const pending = JSON.parse(raw);
      if (Shopify.customerPrivacy?.analyticsProcessingAllowed() === true &&
          Date.now() - pending.created < 120000) added(pending.requested);
    } catch (_) {}
  }
  window.HydeNetCart = {added, queueForCart};
  if (document.readyState === 'complete') consumePending();
  else window.addEventListener('load', consumePending, {once: true});
})();
